import { cordovaInit } from './CordovaInit.js'
import { modalService } from '../services/ModalService.js';
import i18n from '../language.js';
import MediaObject from './MediaObject.js';
import { FILE_SIZE } from '../settings/FILE_SIZE.js';
import { statusBar } from '../services/StatusBar.js';


//https://github.com/DmcSDK/cordova-plugin-mediaPicker
class ImagePicker{
    constructor(){

    // quality is used when drawing image to canvas when resizing
    this.quality=.80;
    
    this.mediaType={
      IMAGE:100,
      IMAGE_AND_VIDEO:101,
      VIDEO:102,
    }
    this.args=undefined;
    }
    

     // RETURNS: (a) an object (getCamera) or (b) alist of objects (getMedia) with propertys:
     // exifOrientation:"0", property from newer camera's to rotate by
     // thumbnail:"base64 data",
     // url:"cdvfile://"; or base 64 data i guess
    
     /* get media from library */
     async getCamera(args){
      

      //this.args=args;
      if(!cordovaInit.isMobile()){
        var dummies=this._getDummyData();
        return dummies[0];
      }

      if(!args){
        args={
          allowEdit : false,
          targetWidth: 1920,
          targetHeight: 1920,
          quality: 90,
          mediaType: window.Camera.MediaType.PICTURE,
          correctOrientation:true,
        };
      }
      
      var output= await new Promise( (resolve,reject) => {

    // uses cordova-plugin-camera
    window.MediaPicker.takePhoto((media)=>{

            media.index=0;//index use to imgs[data.index].src; // media.index=resultMedias.length;
            this._getMediaProperties(media).then( _media =>{
              

              resolve(_media);
              statusBar.resetViewBugMessingThingsUp();
            })
            
      }, error=>{
        
        reject(error);
        statusBar.resetViewBugMessingThingsUp();
      }, args);

    });

    return output;
    }
    
    

    /* get media from library on mobile */
    async getMedias(args){
      
      this.args=args;
      if(!cordovaInit.isMobile()){
        return this._getDummyData();
      }
      
      if(!args){
        args = {
          'selectMode': 100, //101=picker image and video , 100=image , 102=video
          'maxSelectCount': 5, //default 40 (Optional)
          'maxSelectSize': FILE_SIZE.IMAGE, //30 Mb (Optional) only android
        };
      }
     
      var output= await new Promise( (resolve) => {
        window.MediaPicker.getMedias(args, (medias) => {

          
          var promises=[];
          // loop throug medias
          for (var i = 0; i < medias.length; i++) {
            
            // get all promises with media objects
            promises.push(this._awaitData(medias[i]));
            
          }
          
          // if all promises for individual images resolved:
          Promise.all(promises).then ( (result) => {
            // send back the array of objects to initiater.

            resolve(result);
           
            statusBar.resetViewBugMessingThingsUp();
          })
        }) //window.MediaPicker.getMedias
    });
      
    return output;
    }


    async _awaitData(media){
     
      return await new Promise( (resolve) => {
        this._getMediaProperties(media).then( _media =>{
          resolve(_media); // getting the media object
        })
      })
    }
    

    /// build an object with all the media props {url,exifRotation}
    async _getMediaProperties(media){
      
      var _media={};//new MediaObject(media.path,"path",);
      // var _media={}
      
      var fileName=media.uri.split("/").slice(-1).pop().toLowerCase();
      



      
      var compressed_url;
      // compress images and get jpg from HEIC
      await this.mediaPickerCompress(media).then( url=>{
        compressed_url=url;

        // compressing images is usefull for heic images.
        // then we have to convert the name.heic to name.jpg for the backend
        fileName=fileName.split(".").shift()+".jpg";
      })

      _media.fileName=fileName;

      // lets create thumbnail from compressed url
      await this.resizeUrlToBase64(compressed_url,500).then(
        result=>{
          _media.thumbnail=result
        }
      )

      // get internal url for image
      await this._toInternalUrl(compressed_url).then( url => {
        _media.url=url;
      })

      // get exiforientation
      await this._getExifOrientation(media).then( exifOrientation => {
        if(exifOrientation){
          _media.exifOrientation=parseInt(exifOrientation);
        }else{
          _media.exifOrientation=parseInt(0);
        }
        
      }, error=>{ alert("image picker _getExifOrientation() error "+error); })
      
     
      
      // get thumbnail
      /*
      await this.resizeUrlToBase64(_media.url,250).then( result => {
        var base64data=result
        _media.thumbnail=base64data;
      })
      */

      // wait for all promises resolved then return the entire media object
      return await new Promise( (resolve) =>{
          resolve(_media);
      })

    }


    async getFileInfo(media){

      return new Promise((resolve)=>{
        window.MediaPicker.getFileInfo(media.path,"path",function(info){
          resolve(info)
        })
      },
      function(error) { alert("mediapicker file info error.."+error) })
    }



    async mediaPickerCompress(media){
      media.quality=99;
      return new Promise((resolve)=>{
        // compress image converts HEIC to jpg
        window.MediaPicker.compressImage(media, function(compressData) {
          //user compressData.path upload compress img
         
          resolve(compressData.uri);
  
          //alert("compressData="+compressData.path)
        }, function(error) { alert("mediapicker compress error.."+error) });
      })
      
    }

    async _toInternalUrl(url){
      //var a= window.resolveLocalFileSystemURL || window.webkitResolveLocalFileSystemURL
      
      return new Promise((resolve)=>{
        if(!window.resolveLocalFileSystemURL){
          resolve("cordova-file-plugin not installed.");
        }
       
          window.resolveLocalFileSystemURL(url,(entry) =>{
            
            resolve(entry.toInternalURL());

          },
        (error) => {
          resolve("error getting media url"+error);
        })      
      }) // promise
    }


    async _getExifOrientation(media){
      return new Promise((resolve)=>{
        if(!window.MediaPicker){
          resolve("sdk mediapicker not installed not installed.");
        }

        window.MediaPicker.getExifForKey(media.path,"Orientation",
        (exifOrientation) => {
          resolve(exifOrientation);
        },
        () => {
          // no exiforientation pass 0 as default
          resolve(0);
        });
      }) // promise
    }

    
    /*
    async _getThumbnail(media){
      //this._extractThumbnail(media);
      
     
      return await new Promise((resolve, reject)=>{
        if(!window.MediaPicker){
          resolve("sdk mediapicker not installed not installed.");
        }
        // silently Throwing OutOfMemoryError for files too large. this is not catched by the error function..
        var a=window.MediaPicker.extractThumbnail(media, (data) => {
          resolve('data:image/jpeg;base64,' + data.thumbnailBase64);
        },
        error=>{
          alert(error);
        }
        );
      }) // promise
      
    }
    */
    

    // ****************************************
    // use this to resize for base64 thumbnail
    // ****************************************
    async resizeUrlToBase64(localFileUrl,maxSize){
      var file=null;
      var base64Data=null;
      var resizedBase64=null;
      
      
      await this._getFileFromUrl(localFileUrl).then(result=>{
        file=result;
      },error=>{ alert("...error resolving file"+error)});

      await this._getBase64FromFile(file).then(result=>{
        base64Data=result;
      });
      

      await this._getResizedBase64(base64Data,maxSize).then(result=>{
        resizedBase64=result;
      });

      // actually we need to use promise all
      return await new Promise(resolve=>{
        resolve(resizedBase64);
      })
      
    }

    // ****************************************
    // use this to resize for File upload from url
    // ****************************************
    async resizeUrlToBlob(localFileUrl,maxSize){
      var file=null;
      var base64Data=null;
      var resizedBase64=null;

      await this._getFileFromUrl(localFileUrl).then(result=>{
        file=result;
      },error=>{ alert("...error resolving file"+error)});

      await this._getBase64FromFile(file).then(result=>{
        base64Data=result;
      });

     
      await this._getResizedBase64(base64Data,maxSize).then(result=>{
        resizedBase64=result;
      });

      // get blob (byteArray) so we can send with 
      return await new Promise((resolve)=>{
        var blob=this._base64DataToBlob(resizedBase64);
        resolve(blob);
      })
    }

    async _getFileFromUrl(localFileUrl){
      return new Promise((resolve,reject)=>{

        window.resolveLocalFileSystemURL(localFileUrl, (entry) =>{
          entry.file((file) => {
            resolve(file);
          },error=>{
            reject(error);
          }
        );
        })

      });// promise

    }


    // ****************************************
    // use this to resize for File upload from base64 data
    // ****************************************
    async resizeBase64ToBlob(base64Data, maxSize){
      var resizedBase64=null;
      
      await this._getResizedBase64(base64Data,maxSize).then(result=>{
        resizedBase64=result;
      });

      
      // get blob (byteArray) so we can send with 
      return new Promise((resolve)=>{
        var blob=this._base64DataToBlob(resizedBase64);
        resolve(blob);
      })

    }


    // from entry.file from resolveLocalFileSystemURL (cordova-plugin-file)
    async _getBase64FromFile(file){
      return new Promise((resolve)=>{
        
        var reader = new FileReader();
        reader.onloadend = (event) => {
          var base64Data=event.target.result;
          resolve(base64Data);
        };
        reader.readAsDataURL(file);
        
      })
    }

    _getBase64Mimetype(base64Data){
      return base64Data.split(',')[0].match(/:(.*?);/)[1];
    }


    async _getResizedBase64(base64Data,maxSize){
      
      
      if(!maxSize){ maxSize=1920;}
      return new Promise((resolve)=>{
        var arr = base64Data.split(',')
        
        var img=document.createElement('img');
        img.mimeType=arr[0].match(/:(.*?);/)[1];

        
        img.addEventListener('load',(e)=>{
          var c_img=e.currentTarget;
         
          var width=e.currentTarget.naturalWidth;
          var height=e.currentTarget.naturalHeight;

          var maxValue=Math.max(width,height);
         
          // delivers wrong images here.. inverstigate why
          //if(maxValue<=maxSize){
            // do not resize this image, it is already smaller
          //  resolve(base64Data);
            
          //  return;
          //}

          var scaleRatio=maxSize/maxValue;
          
          var scaledWidth=width*scaleRatio;
          var scaledHeight=height*scaleRatio;
          

          // switch width and height if 6 || 8
          var canvas=document.createElement('canvas');
          canvas.width=scaledWidth;
          canvas.height=scaledHeight;
          //document.body.appendChild(canvas);

          var ctx=canvas.getContext('2d');
          ctx.imageSmoothingEnabled = false;
          ctx.drawImage(c_img,0,0,scaledWidth,scaledHeight);

          // get base64 data back
          var resizedBase64=canvas.toDataURL(c_img.mimeType,this.quality);
          
          canvas=null;
          ctx=null;
          
          
          
          resolve(resizedBase64);
          
          
      
        });
        
        img.src=base64Data;
      })
    }  

    // dataurl to blob
    _base64DataToBlob(dataurl) {
      
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]), n = bstr.length;
      var u8arr = new Uint8Array(n);

      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type:mime});
    }

    
    

    // media dummy data
    _getDummyData(){
      
        var result=[];
        var numImages=5;
        for(var i=0;i<numImages;i++){
          
          var item = new MediaObject();
          item.exifOrientation=0;
          item.url=this._makeDummyImage(i);
          
          result.push(item);

        }
       
      //result=this._filterHeic(result);


       return result;
     
    }

    /* returns base64 as url, this wil also work */
    _makeDummyImage(index){
      var sizes=[240,320,480,640];
      var sizeW=sizes[parseInt(Math.random()*sizes.length)];
      var sizeH=sizes[parseInt(Math.random()*sizes.length)];

      var canvas=document.createElement('canvas');
      canvas.width=sizeW;
      canvas.height=sizeH;
        
      var ctx=canvas.getContext('2d');
      ctx.imageSmoothingEnabled = false;
      ctx.fillStyle = ctx.fillStyle = 'hsl(' + 360 * Math.random() + ', 50%, 50%)';
      ctx.fillRect(0, 0, sizeW, sizeH);
      ctx.font = "20px Arial";
      ctx.fillStyle = "#000000";
      ctx.textAlign="center";
      ctx.fillText(index+"-"+sizeW+"x"+sizeH,sizeW*.5,sizeH*.5,sizeW);
      // get base64 data back
      var dummy=canvas.toDataURL('image/jpeg',this.quality);
      return dummy
    }



   
    _filterHeic(medias){
     
      var foundHeic=false;
      this.cleanList=[];

      medias.forEach(media=>{
        if(media.url.indexOf('HEIC')>=0){
          foundHeic=true;
        }else{
          this.cleanList.push(media);
        }
      })
      
      if(foundHeic){
        modalService.createAlert(i18n.t("language.heic_images_not_supported"))
      }
      return this.cleanList;
    }
   

    // ********************************************************
    // make base64 image from image url. for download support
    // url is real url from server not local or cdvfile://
    // for this to work .htaccess is modified to allow access cross domain
    // <IfModule mod_headers.c>    
    // Header set Access-Control-Allow-Origin *
    // </IfModule>
    // ********************************************************
    downloadBase64(imageUrl){

      return new Promise(resolve=>{
        
        // needs serving images with allow cross domain from .thaccess
        var img=document.createElement('img');
        img.crossOrigin = 'anonymous';
        
      
        var handler=()=>{
          img.removeEventListener('load',handler);
          
          
          var canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0,0);
                    
          var dataURL = canvas.toDataURL("image/jpg");
          
          resolve(dataURL);
         
        }
        
        img.addEventListener('load',handler);
        img.addEventListener('error',err=>{
          alert("imagepicker.js load error "+err)
        });
        img.src=imageUrl;
       
      });
      
    }

    isBase64(url){
      var arr = url.split(',')
      var mime;
      
      try{
        // yes is is probabely, unless mimetype is part of the url...
        mime = arr[0].match(/:(.*?);/)[1];
        if(mime){
          return true;
        }
        
      }catch(e){
        return false;
      }
    }

    /* file list is when browser gets files */
    async fileListToMedias(fileList){

      var medias=[];
      //var promises=[];
      
      // cant use forEach with async await
      
      var arr=Array.from(fileList);
      for (var i=0;i<arr.length;i++){
        var file=arr[i];
        var fileSize=file.size;
        if( (fileSize> FILE_SIZE.FILE) && FILE_SIZE.FILE>0){
          var txt=i18n.t("language.file_limit_is")+" "+(FILE_SIZE.FILE/1000000)+"mb"
          await modalService.createAlert(file.name+" "+txt)
          continue; // skip this iteration..
        }

        // wait for base 64 to resolve..
        await this._getBase64FromFile(file).then(result=>{
          var thumb;
          var mimetype=this._getBase64Mimetype(result);
           switch(mimetype){
            case "image/jpeg":
              thumb=result;
            break;
            case "image/png":
              thumb=result;
            break;
            case "audio/mpeg":
              thumb=require('../assets/audio_bg.png')
            break;
            case "application/pdf":
              thumb=require('../assets/pdf_bg.png')
            break;
           }

            var media={
              exifOrientation:"0",
              thumbnail:thumb,
              url:result, /* the base 64 file or blob */
              fileName:file.name,
            }

            medias.push(media);
        })

        
        
      }
    
      
      // send back all medias
      return Promise.resolve(medias);
    }

     
}

export let imagePicker = new ImagePicker();